import React, { useState, useEffect } from 'react';
import { Label } from "../atoms/label";
import { Link } from "react-router-dom";
import image_Hamburger from '../../resources/icons/ico_list.svg';
import image_Pulldown from '../../resources/icons/arw_pulldown.svg';
import useMedia from 'use-media';
import GolfPlanSearchSpContainer from './golfPlanSearchSpContainer';
import { Image } from '../atoms/image';
import img_save from '../../resources/icons/ico_save.svg';
import img_memo from '../../resources/icons/ico_memo.svg';
import { useStore } from "react-redux";

export const GolfPlanTitleContainer = (props) => {
    const { onClickOpenSelectDateWindow,
        onClickOpenStartTimeWindow,
        onClickOpenSelectAreaWindow,
        onClickOpenSavedSearchCriteriaWindow,
        onClickOpenConfirm } = props;

    const sortList = [
        { option: "価格 安い順" }, { option: "価格 高い順" },
    ]
    //state
    const [popFlg, setPopFlg] = useState(false);
    const ConditionsClick = () => {
        //プラン詳細押下時の処理(ポップアップ表示)
        setPopFlg(true);
    };
    const store = useStore();

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const [course, setCourse] = useState("");
    const [group, setGroup] = useState("");
    const [playDate, setPlayDate] = useState("");
    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
        console.log("aaa");

        //コース情報
        const course = store.getState().course;
        let courseName = [];
        course.forEach((data) => {
            if(data.checked){
                courseName.push(data.value);
            }
        })
        setCourse(courseName.join(","));


        const group = store.getState().group;
        let groupVal = "";
        group.forEach((data) => {
            if(data.selected){
                groupVal = data.value;
            }
        });
        setGroup(groupVal);

        const playDate = store.getState().playDate1;
        let date = new Date(playDate);
        let year = date.getFullYear()+"年";
        let month = date.getMonth()+1+"月";
        let day = date.getDate()+"日";
        setPlayDate(year+month+day);
    })


    return (

        <div>
            {popFlg ?
                <GolfPlanSearchSpContainer
                    setState={setPopFlg} //onClick={onClickNext}
                    onClickOpenSelectDateWindow={onClickOpenSelectDateWindow}
                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                    onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
                />
                :
                null
            }
            {Phone ?
                //レスポンシブ対応
                <div style={Phone ? styles.textSp : styles.text}>
                    <div onClick={ConditionsClick} style={styles.textbox}>
                        {playDate +"/"+group}
                    </div>
                    <div>
                        <div>
                            <div style={styles.save}>
                                <Image image={img_save} style={styles.imageSave} />
                                <div style={styles.saveConditions}
                                    onClick={onClickOpenConfirm} >この検索条件を保存</div>
                            </div>
                            <div style={styles.save}>
                                <Image image={img_memo} style={styles.imageSave} />
                                <div style={styles.saveConditions}
                                    onClick={onClickOpenSavedSearchCriteriaWindow} >保存した検索条件</div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div style={Phone ? styles.breadCrumb2 : styles.breadCrumb}>
                    <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                    <Label label=">" style={styles.breadCrumbArrow} />
                    <Link to={"/reserve/golf/search"} style={styles.pan} >ゴルフ予約</Link>
                    <Label label=">" style={styles.breadCrumbArrow} />
                    <Label label="検索結果" style={styles.pan} />
                </div>
            }
        </div>
    )
}

const styles = {
    text: {
        textAlign: "center",
        width: "800px",
    },
    textSp: {
        textAlign: "center",
        width: "100%",
        marginTop: "20px",
    },
    textbox: {
        width: "300px",
        color: "#AAAAAA",
        height:"20px",
        width:"75%",
        fontSize:10,
        border:"1px solid gray",
        margin:"0 auto",
        textOverflow:"ellipsis",
        whiteSpace: "nowrap",
        padding: "3px 5px 0px 5px",
        overflow: "hidden",
    },
    breadCrumb: {
        display: "flex",
        color: "gray",
        marginLeft: "calc(16% + 15px)",
        marginTop: "10px",
        textAlign: "left",
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    panLink: {
        display: "inline-block",
    },
    panLabel: {
        display: "inline-block",
    },
    selectStyle: {
        float: "right",
        width: "150px",
        height: "30px",
        backgroundImage: `url(${image_Hamburger}),url(${image_Pulldown})`,
        backgroundSize: "20px 15px , 25px ",
        backgroundPosition: "left,right",
        backgroundRepeat: "no-repeat",
        webkitAppearance: "none",
        paddingLeft: "35px",
        //direction: "rtl",
        direction: "unset",
        fontSize: "small",
    },
    save: {
        borderBottom: "1px solid",
        margin: "20px 0px 20px 20px",
        fontSize: "small",
        display: "inline-block",
        textAlign: "left",
    },
    imageSave: {
        position: "absolute",
    },
    saveConditions: {
        marginLeft: "25px",
    },
}